import DocumentNameIndicator from './DocumentNameIndicator';

export default DocumentNameIndicator;
